
const Spinner = ({ text, flag }) => {
  let default_dot = 3;
  return (
    <div className="spinner-handle" style={{ 
      margin: flag ? "" : "0% 36%", 
      padding: flag ? "" : "3%" 
    }}  >
    
      <div className="row">
        <div className="d-flex">
          <div className="spinner-border text-info loader-circle">
          </div>
          <div className="loader">
            <span><i>Loading {text ? text : ""}</i></span>
          </div>
          {Array.apply(null, { length: default_dot }).map((elem, index) => (<div className="spinner-grow text-info loader-dot" key={index} >
            <span className="visually-hidden">Loading...</span>
          </div>))}
        </div>
      </div>
    </div>
  );
}

export default Spinner;
